module.exports = __webpack_public_path__ + "img/home_mining.0359d5b.78b56c6c.svg";